import { type UserWorkExperience } from '@borg/types';

const BASE_URL = '/v2/me/work-experience';

type CreateEducation = Omit<UserWorkExperience & { isVolunteering?: boolean }, 'id'>;

class WorkExperienceRepository extends Repository<UserWorkExperience> {
  getMany(isTraining: boolean) {
    return this._getMany({ url: `${BASE_URL}?isVolunteering=${isTraining}` });
  }

  get(id: string) {
    return this._get({ url: `${BASE_URL}/${id}` });
  }

  save(data: UserWorkExperience) {
    return this._save({ url: `${BASE_URL}/${data.id}`, data });
  }

  create(data: CreateEducation) {
    return this._create({ url: BASE_URL, data });
  }

  delete(id: string) {
    return this._delete({ url: `${BASE_URL}/${id}` });
  }
}

export const workExperienceRepository = new WorkExperienceRepository();
